<template>
  <div class="component-grade-post-list">
    <p class="text large bold dark">HSCYLC Certificate Request 证书订购</p>
    <p class="text mt-20">
      峰会将为校友提供证书的补寄服务，证书中将体现校友的姓名、参加年份及所在会场，请根据表格要求填写。对于你的证书寄送有任何问题，可以通过
      <a href="mailto:apply@hsylc.cn" class="bold link">apply@hsylc.cn</a>
      联系我们。
    </p>
    <p class="big bold dark mt-30">我的订单</p>
    <ElTable class="mt-10 table-wrap" :data="orderData">
      <ElTableColumn prop="time" label="日期" width="180"></ElTableColumn>
      <ElTableColumn prop="feeStr" label="金额"></ElTableColumn>
      <ElTableColumn prop="paidState" label="支付状态"></ElTableColumn>
      <ElTableColumn prop="expressState" label="寄送状态"></ElTableColumn>
      <ElTableColumn width="120">
        <template slot-scope="scope">
          <Button class="btn-detail" size="small" skin="grey" v-if="scope.row.isPaid" @click="handleClick(scope.row.id)">查看详情</Button>
          <Button class="btn-detail" size="small" v-else @click="handleClick(scope.row.id)">支付订单</Button>
        </template>
      </ElTableColumn>
    </ElTable>
    <a @click="resetOrderData" class="mt-10 reload link text red bold">刷新</a>
    <Button class="btn-submit mt-30" @click="handleClick()">新建订单</Button>
  </div>
</template>
<script>
import Button from 'components/form/Button';
import { Api, Codes } from 'api';
import { Table as ElTable, TableColumn as ElTableColumn } from 'element-ui';
import Moment from 'moment';
export default {
  name: 'List',
  components: {
    ElTable,
    ElTableColumn,
    Button
  },
  computed: {
    orderData() {
      return this.orders.map(item => ({
        ...item,
        time: Moment(item.updated_at || item.created_at).format('YYYY-MM-DD HH:mm:ss'),
        feeStr: `${item.fee}元`,
        isPaid: !!item.paid_at,
        paidState: item.paid_at ? '已支付' : '未支付',
        expressState: item.express_no ? '已发货' : '未发货'
      }));
    }
  },
  data: () => ({
    orders: []
  }),
  async created() {
    await this.resetOrderData();
  },
  methods: {
    async resetOrderData() {
      this.$loading.show();
      let res = await Api.get.getStudentTranscriptCertificateDeliveryOrders();
      if (res.status === Codes.SUCCESS && res.data?.orders?.length) {
        this.orders = res.data.orders;
      }
      this.$loading.hide();
    },
    reload() {
      window.location.reload();
    },
    handleClick(id) {
      let href = '/student/manage/certificate/post/detail';
      if (id) {
        href += '/' + id;
      }
      this.$windowOpen(href);
    }
  }
};
</script>
